export class AggregateDownloadInfo {
  isLoadingInfo = false;
  totalHighresFilesToDownload: number;
  totalHighresDownloadSize: number;

  totalProxyFilesToDownload: number;
  totalProxyDownloadSize: number;

  totalNonVideoFilesToDownload: number;
  totalNonVideoDownloadSize: number;

  totalInaccessibleFiles: number;
  totalHighresDeletedFiles: number;

  constructor(private isProxyMode: boolean) {
    this.totalHighresFilesToDownload = 0;
    this.totalHighresDownloadSize = 0;

    this.totalProxyFilesToDownload = 0;
    this.totalProxyDownloadSize = 0;

    this.totalNonVideoFilesToDownload = 0;
    this.totalNonVideoDownloadSize = 0;

    this.totalInaccessibleFiles = 0;
    this.totalHighresDeletedFiles = 0;
  }

  countDownloads(includeHighres: boolean) {
    // Non video items don't have separate proxies to
    // download, so we always want to count them regardless
    // of the highres/proxy mode
    let count = this.totalNonVideoFilesToDownload;

    if (includeHighres || !this.isProxyMode) {
      count += this.totalHighresFilesToDownload;
    }

    if (this.isProxyMode) {
      count += this.totalProxyFilesToDownload;
    }
    return count;
  }

  updateInfo(needsHighres: boolean, needsProxy: boolean, isNonVideoFile: boolean, highresSize: number, proxySize: number, isAccessible: boolean, wasHighresDeleted_: boolean) {
    if (isAccessible) {
      if (needsHighres && wasHighresDeleted_) {
        this.totalHighresDeletedFiles += 1;
        return;
      }

      this.totalHighresFilesToDownload += needsHighres ? 1 : 0;
      this.totalHighresDownloadSize += needsHighres ? highresSize : 0;

      this.totalProxyFilesToDownload += needsProxy ? 1 : 0;
      this.totalProxyDownloadSize += needsProxy ? proxySize : 0;

      this.totalNonVideoFilesToDownload += isNonVideoFile ? 1 : 0;
      this.totalNonVideoDownloadSize += isNonVideoFile ? highresSize : 0;
    } else {
      const needsDownload = needsHighres || needsProxy;
      this.totalInaccessibleFiles += ((this.isProxyMode && needsDownload) || needsHighres) ? 1 : 0;
    }
  }
}

